<template>
  <ConfirmDialog
    v-bind="control"
    confirm-style="error"
    confirm-text="pb2.modePropertiesView.modeDeleteConfirmLabel"
    :dialog-title="translate('pb2.modePropertiesView.modeDeleteConfirmTitle')"
  >
    {{ translate('pb2.modePropertiesView.modeDeleteConfirmMessage') }} "{{ mode.linkName }}" ?
  </ConfirmDialog>
</template>

<script setup>
import useCloseOthers from '@nicolaudie-group/ng-ui-kit/composables/useCloseOthers'
import useConfirmDialog from '@nicolaudie-group/ng-ui-kit/composables/useConfirmDialog'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import useTranslate from '@/composables/useTranslate'
import useModeStore from '@/stores/mode.store'
import { onBeforeUnmount, watch } from 'vue'

const props = defineProps({
  /**
   * Mode of which to confirm deletion
   */
  mode: { type: Object, required: true },
  /**
   * Wether the confirm is active or not
   */
  value: { type: Boolean, required: true },
  /**
   * Additionnal options passed to modes store when using the delete action
   */
  options: { type: Object, default: () => ({}) },
})

const emit = defineEmits(['input'])

const modeStore = useModeStore()

const { translate } = useTranslate()

function deleteMode() {
  return modeStore.delete({
    _uid: props.mode.data._uid,
    ...props.options,
  })
}

const {
  control,
  state: deleteModeConfirm,
  open: openConfirm,
  cancel: cancelConfirm,
} = useConfirmDialog(deleteMode)
useCloseOthers(cancelConfirm, deleteModeConfirm)

watch(deleteModeConfirm, (state) => {
  if (state !== props.value) {
    emit('input', state)
  }
})

watch(() => props.value, (state) => {
  if (state !== deleteModeConfirm.value) {
    if (state) {
      openConfirm()
    } else {
      cancelConfirm()
    }
  }
})

onBeforeUnmount(() => {
  if (props.value) {
    // Make sure that the state of the confirm is updated in the parent
    emit('input', false)
  }
})
</script>
